let sessionError: boolean;

export function setSessionError(error: boolean): void {
  sessionError = error;
}

export function getSessionError(): boolean {
  return sessionError;
}
